import cm from 'classnames';
import styles from '../_editor-actions.module.scss';

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  selected: boolean;
  className?: string;
  title: string;
  desc: string;
}

export const ActionsBtnOpt = ({ title, desc, className, selected, ...rest }: Props) => {
  return (
    <button
      {...rest}
      className={cm(styles.EditorActions__btnOption, className, {
        [styles['EditorActions__btnOption--selected']]: selected,
      })}
    >
      <h3>{title}</h3>
      <p>{desc}</p>
    </button>
  );
};
